export enum LiveClassEventState {
  SIGNUP = 'SIGNUP',
  SIGNUP_LESSON_SELECTION = 'SIGNUP_LESSON_SELECTION',
  SIGNUP_CONFIRMED = 'SIGNUP_CONFIRMED',
  SIGNUP_CANCEL = 'SIGNUP_CANCEL',
  JOINED = 'JOINED',
  REJOINED = 'REJOINED',
  NONE = 'NONE',
  LOCKED = 'LOCKED',
  CLASS_REJECTED = 'CLASS_REJECTED',
  CLASS_READY = 'CLASS_READY',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/LiveClassEventState.ts